import { render, staticRenderFns } from "./LightProgramming.vue?vue&type=template&id=e71a8870&"
import script from "./LightProgramming.vue?vue&type=script&lang=js&"
export * from "./LightProgramming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports